<template>
  <!-- prettier-ignore -->
  <index-content>
    <template #options>
      <nb-download :url="CUSTOMER_ORDER_CSV_URL" :params="condition" />
    </template>
    <search-condition searchable :loading="searching" @do-search="search">
      <ns-company v-model="condition.companyId" />
      <n-field-enum v-model="condition.type" enum-name="MobileType" label="type" all-option />
      <ns-product v-model="condition.productId" :company-id="condition.companyId" :mobile-type="condition.type" all-option />
      <n-field-enum v-model="condition.status" enum-name="CustomerOfferStatus" label="status" all-option />
      <n-field-id v-model="condition.customerId" label="customerId" />
      <n-field-datetime v-model="condition.from" label="from" />
      <n-field-datetime v-model="condition.to" label="to" />
    </search-condition>
    <n-table :total="total" :page-no="pageNo" :page-size="pageSize" :searched="searched" :searching="searching" :has-result="hasResult" @on-page-no="onPageNo" @on-page-size="onPageSize">
      <table class="table table-bordered table-hover table-striped text-center n-table">
        <thead>
          <tr>
            <th class="col-weight-8">{{ $t('label.company') }}</th>
            <th class="col-weight-8">{{ $t('label.customerId') }}</th>
            <th class="col-weight-8">{{ $t('label.mobileType') }}</th>
            <th class="col-weight-30">{{ $t('label.storeProductId') }}</th>
            <th class="col-weight-8">{{ $t('label.status') }}</th>
            <th class="n-table-timestamp">{{ $t('label.orderTime') }}</th>
            <th class="n-table-timestamp">{{ $t('label.expireTime') }}</th>
            <th v-table-action>{{ $t('label.action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td v-selection:[`company.company`]="row.companyId"></td>
            <td class="n-ellipsis">
              <n-modal-link name="customer.profile" :value="row.customerId" />
            </td>
            <td v-enums:MobileType="row.mobileType"></td>
            <td>{{ row.storeProductId }}</td>
            <td v-enums:CustomerOrderStatus="row.status"></td>
            <td>{{ row.orderTime | datetime }}</td>
            <td>{{ row.expireTime | datetime }}</td>
            <td class="n-button-box">
              <nb-custom text="detail" @on-click="openModal(row)" />
            </td>
          </tr>
        </tbody>
      </table>
    </n-table>
  </index-content>
</template>

<script>
import CustomerView from './view';
import PaginateMixin from '@/mixins/paginate-mixin';
import ModalCustomerOrder from './ModalCustomerOrder';
import { CUSTOMER_ORDER_CSV_URL, fetch } from '@/api/customer/customer-customer-order';

export default CustomerView.extend({
  name: 'CustomerCustomerOrder',
  mixins: [PaginateMixin],
  data() {
    return {
      condition: {
        companyId: 0,
        productId: 0,
        customerId: null,
        type: 0,
        status: 0,
        from: this.oneWeekAgo,
        to: this.eod,
      },
      CUSTOMER_ORDER_CSV_URL,
    };
  },
  methods: {
    doSearch(params) {
      let p = { ...params, ...this.condition };
      return fetch(p);
    },
    parse(rows) {
      this.records = rows.records;
    },
    openModal(model = {}) {
      this.createModal(ModalCustomerOrder, { model, on: this });
    }
  },
});
</script>

<style lang="scss" scoped>
@import '~@/style/table';

.n-table {
  min-width: 1080px;

  th.rw-action {
    width: 4.5rem;
  }

  th.ro-action {
    width: $action-detail;
  }
}
</style>
